import { TryShadeSection } from '@we-make-websites/ui-lib';
import { useContext } from 'use-context-selector';
import { GlobalContentContext } from 'components/globalContentContext/GlobalContentContext';
import { ProductContext } from 'components/productContext/ProductProvider';

export const TryShadeSectionConnected = () => {
  const productContext = useContext(ProductContext);
  const globalContentContext = useContext(GlobalContentContext);

  if (productContext === undefined)
    throw new Error(
      'TryShadeSectionConnected must be used within a ProductContext'
    );

  if (globalContentContext === undefined)
    throw new Error(
      'TryShadeSectionConnected must be used within a GlobalContentContext'
    );

  const { tryShadeSection } = productContext;
  const { productIconsSettings } = globalContentContext;

  const tryShadeCardsWithIcons = tryShadeSection?.tryShadeCards?.map((card) => {
    const icons =
      productIconsSettings?.find((icons) => icons.type === card.productType)
        ?.icons ?? [];

    return {
      ...card,
      icons,
    };
  });

  return (
    <TryShadeSection
      {...tryShadeSection}
      tryShadeCards={tryShadeCardsWithIcons}
    />
  );
};
